// 数组转一维数组
export function treeToOneArray(treeData, key) {
  const flattenList = []
  _.forEach(treeData, (item) => {
    const cloneItem = _.cloneDeep(item)
    delete cloneItem[key]
    flattenList.push(cloneItem)
    if (_.isArray(item[key])) {
      const flattenChildren = treeToOneArray(item[key], key)
      flattenList.push(...flattenChildren)
    }
  })
  return flattenList
}
// 生成guid
export function generateGUID() {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}
// base64转base32
export function base64ToBase32(base64String) {
  const decodedString = atob(base64String)
  const byteArray = new Uint8Array(decodedString.length); for (let i = 0; i < decodedString.length; i += 1) {
    byteArray[i] = decodedString.charCodeAt(i)
  }
  const base32Alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'
  let base32String = ''
  let bits = 0
  let value = 0
  for (let i = 0; i < byteArray.length; i += 1) {
    value = (value << 8) | byteArray[i]
    bits += 8; while (bits >= 5) {
      base32String += base32Alphabet[(value >>> (bits - 5)) & 0x1F]
      bits -= 5
    }
  }
  if (bits > 0) {
    base32String += base32Alphabet[(value << (5 - bits)) & 0x1F]
  }
  return `${base32String}====`
}
export default null
